import * as React from 'react';
import { useTranslation } from 'react-i18next';

// Utils
import { navigate } from '@toolkit/util/app';
// Constants
import { ROUTES } from '@toolkit/const/app';
import { API_URL } from '@src/shared/src/const/api';
// Actions
// Models
import { UserModel, OrganizationModel } from '@src/shared/src/models';
// Interfaces
// Components
import { ConciergeLink } from '@src/components/ConciergeLink';
// Styles
import '../styles/Navbar.scss';

type Props = {
  currentUser?: UserModel;
  currentOrganization?: OrganizationModel;
  isCurrentUserNotTraveller?: boolean;
  onLogout: (val: string) => void;
};

export const Navbar: React.FC<Props> = (props) => {
  const { currentUser, currentOrganization, isCurrentUserNotTraveller, onLogout } = props;
  const { t } = useTranslation();
  const adminUserLink = `${API_URL.DEFAULT}/org_admin/travel/bookings`;

  const adminCompanyLink = `${API_URL.DEFAULT}/org_admin/organizations/${currentOrganization?.id}/users`;
  return (
    <div className="tcp-navbar">
      <div className="tcp-navbar-item tcp-navbar-item-dropdown">
        <i className="icon-help" />
        {t('navbar.header.label.help')}
        <i className="icon-keyboard_arrow_down tcp-navbar-dropdown-icon" />
        <ul className="tcp-navbar-dropdown">
          <li
            className="tcp-navbar-dropdown-item" onClick={() => window.open(t('navbar.header.label.help_link'))}>
            <i className="icon-help_center" />
            {t('navbar.header.label.help_center')}
          </li>
          <li className="tcp-navbar-dropdown-item">
            <ConciergeLink>
              <i className="icon-contact_mail" />
              {t('navbar.header.label.contact_form')}
            </ConciergeLink>
          </li>
        </ul>
      </div>
      <div className="tcp-navbar-item" onClick={() => navigate(`${ROUTES.HOME}`)}>
        <i className="icon-search2" />
        {t('navbar.header.label.search')}
      </div>
      <div className="tcp-navbar-item" onClick={() => window.location.assign(adminUserLink)}>
        <i className="icon-tickets" />
        {t('navbar.header.label.tickets')}
      </div>
      {currentUser && (
        <div className="tcp-navbar-item tcp-navbar-item-dropdown">
          {currentUser.firstName} {currentUser.lastName}
          <i className="icon-keyboard_arrow_down tcp-navbar-dropdown-icon" />
          <ul className="tcp-navbar-dropdown">
            {isCurrentUserNotTraveller && (
              <li
                className="tcp-navbar-dropdown-item"
                onClick={() => window.location.assign(adminCompanyLink)}>
                <i className="icon-people" />
                {t('navbar.header.label.company_account')}
              </li>
            )}
            <li
              className="tcp-navbar-dropdown-item"
              onClick={() => window.location.assign(adminUserLink)}>
              <i className="icon-person" />
              {t('navbar.header.label.user_account')}
            </li>
            <li className="tcp-navbar-dropdown-item" onClick={() => onLogout('')}>
              <i className="icon-exit_to_app" />
              <strong>{t('navbar.header.label.logout')}</strong>
            </li>
          </ul>
        </div>
      )}
    </div>
  );
};
export default Navbar;
